export default "__VITE_ASSET__t9UG0P2k__"